import Immutable from 'immutable';
import {
  CLEAR_BAGGAGE_MANIFEST_PRINT,
  FLAG_GETTING_BAGGAGE_MANIFEST_PRINT,
  GET_BAGGAGE_MANIFEST_PRINT,
} from '../../../actions/types/baggage/BaggageManifestPrint';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BAGGAGE_MANIFEST_PRINT:
      return state.setIn(['current', 'loading'], payload);
    case GET_BAGGAGE_MANIFEST_PRINT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BAGGAGE_MANIFEST_PRINT:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
